import { axiosClientCore as axiosClient } from "@duosoftbg/nacid-frontoffice-components";

const endpoints = {
  getGradingScalesByCountryCodeAndYear: "/grading-scales",
  getGradingScaleDetailsByScaleId: "/grading-scale-details/by-scale-id",
  getGradingScaleCountries: "/grading-scales/countries",
};

export const getGradingScalesByCountryCodeAndYear = (countryCode, year) => () => {
  return axiosClient.get(`${endpoints.getGradingScalesByCountryCodeAndYear}`, {
    params: {
      countryCode,
      year,
    },
  });
};

export const getGradingScaleDetailsByScaleId = (scaleId) => () => {
  return axiosClient.get(`${endpoints.getGradingScaleDetailsByScaleId}`, {
    params: {
      scaleId,
    },
  });
};

export const getGradingScaleCountries = () => () => {
  return axiosClient.get(`${endpoints.getGradingScaleCountries}`);
};
